<!--会议草稿组件-->
<template>
  <div class="cardtable">
    <v-flex xs12>
      <div class="event-filter">
        <v-flex xs12>
          <v-layout row>
            <v-flex xs10>
              <div class="event-title">
                {{ this.$t('masterData.filter') }}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row>
          <v-flex xs12 md3>
            <div class="event-filter-title">
              {{ this.$t('system.configitem') }}
            </div>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <v-select
              class="filter-interval event-filter-content"
              :items="category"
              v-model="filter.type"
            >
            </v-select>
          </v-flex>
          <v-flex xs2>
            <v-btn
              @click="clearfilter()"
              color="#1cade4"
              class="Btn_add"
              depressed
              >{{ this.$t('masterData.clearfilter') }}</v-btn
            >
          </v-flex>
          <v-flex xs2 v-if="ismodify">
            <v-btn @click="add()" color="#1cade4" class="Btn_add" depressed>{{
              this.$t('masterData.add')
            }}</v-btn>
          </v-flex>
          <v-flex xs2>
            <v-btn
              depressed
              color="#1cade4"
              class="Btn_add"
              @click="getdatas()"
              >{{ this.$t('masterData.apply') }}</v-btn
            >
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs8> </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12 style="background-color:white!important;">
      <div class="allevent-content">
        <div class="table-header">
          <v-layout row>
            <v-flex xs12 md3>
              <span>{{ this.$t('system.configitem') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('system.key') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('system.val') }}</span>
            </v-flex>
            <v-flex xs12 md3>
              <span>{{ this.$t('system.action') }}</span>
            </v-flex>
          </v-layout>
        </div>

        <div class="table-row" v-for="(item, key) in system.items" :key="key">
          <v-layout row>
            <v-flex xs12 md3>
              <div class=" table-cell">
                {{ item.type }}
              </div>
            </v-flex>
            <v-flex xs12 md3>
              <div :title="item.EventName" class=" table-cell">
                {{ item.key }}
              </div>
            </v-flex>
            <v-flex xs12 md3>
              <div class=" table-cell">
                {{ item.val }}
              </div>
            </v-flex>
            <v-flex xs12 md3>
              <v-layout row>
                <v-flex xs12 md4 v-if="ismodify">
                  <div @click="editData(key)" class=" table-cell  event-no">
                    {{ edit }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <div v-if="system.items.length == 0" class="partipant-module-MESSAGE">
          {{ this.$t('emptymsg') }}
        </div>
        <v-pagination
          v-if="length > 0"
          v-model="page"
          :length="length"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-flex>
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs3> {{ this.$t('common.edit') }}</v-flex>
              <v-flex xs8></v-flex>
              <v-flex xs1>
                <v-icon @click="dialogclose()">mdi-close</v-icon>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <div class="event-filter-title">配置项</div>
            </v-flex>
          </v-layout>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <v-select
                required
                class="filter-interval event-filter-content"
                :items="category"
                v-model="system.info.type"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <div class="event-filter-title">键</div>
            </v-flex>
          </v-layout>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <v-text-field
                required
                v-model="system.info.key"
                class="filter-interval event-filter-content"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <div class="event-filter-title">值</div>
            </v-flex>
          </v-layout>
          <v-layout row class="editcontent">
            <v-flex xs12>
              <v-text-field
                required
                v-model="system.info.val"
                class="filter-interval event-filter-content"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row class="effective">
            <v-flex xs12>
              <v-btn
                depressed
                color="#1cade4"
                class="Btn_add"
                @click="saveData()"
                >{{ this.$t('common.save') }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <core-dataloading ref="dataload"></core-dataloading>
    <core-confirm ref="myConfirm" @userBehavior="userBehavior"></core-confirm>
  </div>
</template>
<style>
.editcontent {
  margin-top: 10px;
  margin-left: 60px;
  margin-right: 60px;
}
.effective {
  margin-left: 70px;
  margin-right: 60px;
}
</style>
<script>
import { mapState } from 'vuex'
import { PowerJudge } from '@/common/common'
import CoreDataloading from '@/components/core/dataloading.vue'
import CoreConfirm from '@/components/core/confirm.vue'
import {
  configurationList,
  configurationCreateOrUpdate,
  configurationDelete,
  configurationtype
} from '@/request/api'
export default {
  components: {
    CoreDataloading,
    CoreConfirm
  },
  data: () => ({
    configitems: [],
    search: '',
    length: 0,
    page: 1,
    pagesize: 8,
    dialog: false,
    filter: {
      type: null
    },
    category: []
  }),
  mounted: function() {
    this.$nextTick(() => {
      this.getdatas()
      this.configurationtype()
    })
    this.base.confirmDialog = this.$refs.myConfirm
  },
  watch: {
    page() {
      //this.getdrafts()
    }
  },
  computed: {
    ...mapState({
      system: state => state.system,
      base: state => state.base
    }),
    del() {
      return this.$t('common.delete')
    },
    ismodify() {
      return PowerJudge('config-modify')
    },
    edit() {
      return this.$t('common.edit')
    }
  },
  methods: {
    add() {
      var param = {
        id: 0,
        type: null,
        key: null,
        val: null
      }
      this.system.info = param
      this.dialog = true
    },
    dialogclose() {
      this.dialog = false
    },
    clearfilter() {
      this.filter = {
        type: null
      }
    },
    getdatas() {
      var _this = this
      let param = {
        type: _this.filter.type,
        t: new Date().getTime()
      }
      this.base.eventdom
        .CommonEventApi(
          configurationList,
          param,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在查询数据'
        )
        .then(res => {
          _this.system.items = res
        })
    },
    deleteData(key) {
      var _this = this
      var item = this.system.items[key]
      this.system.id = item.id
      this.base.eventdom
        .CommonEventApi(
          configurationDelete,
          null,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在删除数据'
        )
        .then(() => {
          _this.$refs.myConfirm.show('删除成功', {
            type: 'alert',
            data: 'success'
          })
        })
    },
    saveData() {
      var _this = this
      var param = this.system.info
      this.base.eventdom
        .CommonEventApi(
          configurationCreateOrUpdate,
          param,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在保存数据'
        )
        .then(() => {
          _this.dialog = false
          _this.$refs.myConfirm.show('保存成功', {
            type: 'alert',
            data: 'success'
          })
        })
    },
    configurationtype() {
      var _this = this
      this.base.eventdom
        .CommonEventApi(configurationtype, null, null, null, null)
        .then(res => {
          var items = []
          for (var i = 0; i < res.length; i++) {
            var item = {}
            item.text = res[i].name
            item.value = res[i].id
            items.push(item)
          }

          _this.category = items
        })
    },
    userBehavior(outerData) {
      if (outerData == 'success') {
        this.dialog = false
        this.getdatas()
      }
    },
    editData(key) {
      var item = this.system.items[key]
      var typeid = this.category.filter(x => {
        return x.text == item.type
      })[0].value
      var param = {
        id: item.id,
        type: typeid,
        key: item.key,
        val: item.val
      }
      this.system.info = param
      this.dialog = true
    }
  }
}
</script>
